const {produce} = require("immer");
const initialState = {
  services: [],
  loginPage: "Presentation"
};

/**
 * Top level Reducer
 */

function loginReducer(state = initialState, action) {
  switch (action.type) {

    case "LOGIN_PAGE":
      return produce(state, draft => {
        draft.loginPage = action.loginPage;
      });

    case "SET_INFO":
      return produce(state, draft => {
        draft.services = action.services;
      });

    default:
      return state;
  }
}

module.exports = loginReducer;
